const TermsOfService = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto", fontFamily: "sans-serif", lineHeight: 1.6 }}>
      <h1>Terms of Service</h1>
      <p>Effective Date: October 1, 2025</p>

      <h2>Acceptance of Terms</h2>
      <p>By using our website or services, you agree to comply with and be bound by these Terms of Service. If you do not agree, please do not use our services.</p>

      <h2>Use of Services</h2>
      <ul>
        <li>You agree to use our services only for lawful purposes and in accordance with these Terms.</li>
        <li>You may not use the services in any way that could harm the website, other users, or third parties.</li>
      </ul>

      <h2>Account Responsibility</h2>
      <p>If you create an account, you are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.</p>

      <h2>Intellectual Property</h2>
      <p>All content, logos, and materials provided on our website are the property of the site owner and protected by applicable intellectual property laws.</p>

      <h2>Disclaimers</h2>
      <p>Our services are provided "as is" without warranties of any kind, either express or implied. We do not guarantee accuracy, reliability, or availability of our services.</p>

      <h2>Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, we shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of our services.</p>

      <h2>Changes to Terms</h2>
      <p>We may update these Terms from time to time. Continued use of our services constitutes acceptance of any changes.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us at <a href="mailto:log3holmi3@gmail.com">log3holmi3@gmail.com</a>.</p>
    </div>
  )
}

export default TermsOfService;